/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerFindSavedLocationQueryResponse,
  TelegramProductsUserControllerFindSavedLocationQueryParams,
  TelegramProductsUserControllerFindSavedLocation401,
} from '../types/TelegramProductsUserControllerFindSavedLocation.ts';

function getTelegramProductsUserFindSavedLocationUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/products/saved-location` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/saved-location}
 */
export async function telegramProductsUserFindSavedLocation(
  params: TelegramProductsUserControllerFindSavedLocationQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerFindSavedLocationQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindSavedLocation401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsUserFindSavedLocationUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
